import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DevicesService, InstalledApplication } from '@rocksoft/locations-sdk';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  InstalledApplicationsApiActions,
  InstalledApplicationsResolverActions,
} from './installed-applications.actions';

@Injectable()
export class InstalledApplicationsEffects {
  private readonly devicesServices = inject(DevicesService);
  private readonly actions$ = inject(Actions);

  installedApplicationsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InstalledApplicationsResolverActions.installedApplicationsRequested),
      mergeMap(() =>
        safeMap(
          this.devicesServices.getInstalledApplications(),
          (installedApplications: InstalledApplication[]) =>
            InstalledApplicationsApiActions.installedApplicationsLoaded({ installedApplications }),
          (error) => InstalledApplicationsApiActions.installedApplicationsLoadedError({ error })
        )
      )
    );
  });
}
